import { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { login, getRolFromToken, solicitarRecuperacion, register } from './services/auth';
import './Login.css';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [regNombre, setRegNombre] = useState('');
  const [regEmpresa, setRegEmpresa] = useState('');
  const [regTelefono, setRegTelefono] = useState('');
  const [regEmail, setRegEmail] = useState('');
  const [regPassword, setRegPassword] = useState('');
  const [regError, setRegError] = useState('');
  const [regLoading, setRegLoading] = useState(false);
  const [regSuccess, setRegSuccess] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [currentPhrase, setCurrentPhrase] = useState(0);
  
  const [showRecoveryModal, setShowRecoveryModal] = useState(false);
  const [recoveryEmail, setRecoveryEmail] = useState('');
  const [recoveryError, setRecoveryError] = useState('');
  const [recoverySuccess, setRecoverySuccess] = useState('');
  const [recoveryLoading, setRecoveryLoading] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await login({ username: email, password });
      navigate('/dashboard');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentPhrase((prev) => (prev + 1) % 4);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const handleRegistro = async (e) => {
    e.preventDefault();
    setRegLoading(true);
    setRegError('');
    setRegSuccess('');

    try {
      await register({
        nombre: regNombre,
        email: regEmail,
        telefono: regTelefono,
        password: regPassword,
        nombre_empresa: regEmpresa,
        telefono_whatsapp: regTelefono
      });
      
      setRegNombre('');
      setRegEmpresa('');
      setRegTelefono('');
      setRegEmail('');
      setRegPassword('');
      
      setRegSuccess(`¡Registro exitoso! Te hemos enviado un enlace de verificación a ${regEmail}. Revisa tu bandeja de entrada y haz clic para activar tu cuenta antes de iniciar sesión.`);
      
      setTimeout(() => {
        setShowModal(false);
        setRegSuccess('');
      }, 4000);
      
    } catch (err) {
      setRegError(err.message);
    } finally {
      setRegLoading(false);
    }
  };

  const handleRecuperacion = async (e) => {
    e.preventDefault();
    setRecoveryLoading(true);
    setRecoveryError('');
    setRecoverySuccess('');

    try {
      await solicitarRecuperacion(recoveryEmail);
      setRecoverySuccess(`Se ha enviado un correo con las instrucciones para recuperar tu contraseña a ${recoveryEmail}. Revisa tu bandeja de entrada.`);
      setRecoveryEmail('');
      setTimeout(() => {
        setShowRecoveryModal(false);
        setRecoverySuccess('');
      }, 4000);
    } catch (err) {
      setRecoveryError(err.message || 'Error al solicitar recuperación');
    } finally {
      setRecoveryLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-branding">
        <div className="login-branding__content">
          <img 
            src="/sinteligen4.png" 
            alt="KleverBotBase" 
            className="login-branding__logo"
          />
          <p className="login-branding__subtitle">
            ASISTENTE INTELIGENTE PARA WHATSAPP
          </p>
        </div>

        <div className="login-branding__carousel">
          {[
            "Automatiza la gestión de citas con un bot 24/7 en WhatsApp",
            "Conecta tu número de WhatsApp y responde automáticamente a tus clientes",
            "Sube tus documentos y el bot responderá con información precisa",
            "Multi-empresa: cada cliente gestiona su propio negocio y sus citas"
          ].map((text, index) => (
            <p
              key={index}
              className={`login-branding__phrase ${index === currentPhrase ? 'active' : ''}`}
            >
              {text}
            </p>
          ))}
        </div>

        <div className="login-branding__orb login-branding__orb--1" />
        <div className="login-branding__orb login-branding__orb--2" />
      </div>

      <div className="login-form-side">
        <form className="login-form" onSubmit={handleSubmit}>
          <div className="login-form__header">
            <h2>Iniciar Sesión</h2>
            <p>Ingresa tus credenciales</p>
          </div>

          {error && <div className="login-error">{error}</div>}

          <div className="login-form__field">
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="correo@ejemplo.com"
              disabled={loading}
            />
          </div>

          <div className="login-form__field">
            <label>Contraseña</label>
            <div className="password-wrapper">
              <input
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="••••••••"
                disabled={loading}
                className="password-input"
              />
              <button
                type="button"
                className="toggle-password"
                onClick={() => setShowPassword(!showPassword)}
                aria-label={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
              >
                {showPassword ? '👁️' : '👁️‍🗨️'}
              </button>
            </div>
          </div>

          <button className="login-btn" type="submit" disabled={loading}>
            {loading ? 'Iniciando...' : 'Ingresar'}
          </button>

          <div className="login-form__footer">
            <p className="login-register-link">
              ¿No tienes cuenta? <button type="button" onClick={() => setShowModal(true)} className="link-button">Regístrate aquí</button>
            </p>
            <p className="login-forgot-link">
              <button type="button" onClick={() => setShowRecoveryModal(true)} className="link-button">¿Olvidaste tu contraseña?</button>
            </p>
            <div className="login-legal-links">
              <Link to="/politica-privacidad" target="_blank" className="privacy-link">Política de Privacidad</Link>
              <span className="legal-separator">|</span>
              <Link to="/terminos-servicio" target="_blank" className="privacy-link">Términos de Servicio</Link>
              <span className="legal-separator">|</span>
              <Link to="/eliminacion-datos" target="_blank" className="privacy-link">Eliminación de Datos</Link>
            </div>
          </div>
        </form>
      </div>

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Crear Cuenta</h2>
              <button className="modal-close" onClick={() => setShowModal(false)}>×</button>
            </div>
            
            {regSuccess ? (
              <div className="modal-success">{regSuccess}</div>
            ) : (
              <form onSubmit={handleRegistro}>
                <div className="modal-field">
                  <label>Nombre completo</label>
                  <input
                    type="text"
                    value={regNombre}
                    onChange={(e) => setRegNombre(e.target.value)}
                    required
                    placeholder="Tu nombre completo"
                  />
                </div>
                <div className="modal-field">
                  <label>Nombre de la empresa</label>
                  <input
                    type="text"
                    value={regEmpresa}
                    onChange={(e) => setRegEmpresa(e.target.value)}
                    required
                    placeholder="Nombre de tu negocio"
                  />
                </div>
                <div className="modal-field">
                  <label>Teléfono</label>
                  <input
                    type="text"
                    value={regTelefono}
                    onChange={(e) => setRegTelefono(e.target.value)}
                    required
                    placeholder="0999999999"
                  />
                </div>
                <div className="modal-field">
                  <label>Email</label>
                  <input
                    type="email"
                    value={regEmail}
                    onChange={(e) => setRegEmail(e.target.value)}
                    required
                    placeholder="correo@ejemplo.com"
                  />
                </div>
                <div className="modal-field">
                  <label>Contraseña</label>
                  <input
                    type="password"
                    value={regPassword}
                    onChange={(e) => setRegPassword(e.target.value)}
                    required
                    placeholder="Mínimo 8 caracteres"
                  />
                </div>
                {regError && <div className="modal-error">{regError}</div>}
                <button type="submit" className="modal-btn" disabled={regLoading}>
                  {regLoading ? 'Registrando...' : 'Registrarse'}
                </button>
                <p className="modal-footer-text">
                  Al registrarte aceptas nuestra <Link to="/politica-privacidad" target="_blank" className="privacy-link">Política de Privacidad</Link> y nuestros <Link to="/terminos-servicio" target="_blank" className="privacy-link">Términos de Servicio</Link>.
                </p>
              </form>
            )}
          </div>
        </div>
      )}

      {showRecoveryModal && (
        <div className="modal-overlay" onClick={() => setShowRecoveryModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Recuperar Contraseña</h2>
              <button className="modal-close" onClick={() => setShowRecoveryModal(false)}>×</button>
            </div>
            
            {recoverySuccess ? (
              <div className="modal-success">{recoverySuccess}</div>
            ) : (
              <form onSubmit={handleRecuperacion}>
                <div className="modal-field">
                  <label>Email</label>
                  <input
                    type="email"
                    value={recoveryEmail}
                    onChange={(e) => setRecoveryEmail(e.target.value)}
                    required
                    placeholder="correo@ejemplo.com"
                    disabled={recoveryLoading}
                  />
                </div>
                {recoveryError && <div className="modal-error">{recoveryError}</div>}
                <button type="submit" className="modal-btn" disabled={recoveryLoading}>
                  {recoveryLoading ? 'Enviando...' : 'Enviar Instrucciones'}
                </button>
              </form>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default Login;